<template>
  <div v-if="rating && rating.reviews" class="row f16-l21" :class="maxWidthClass" dir="rtl">
    <div v-if="this.$isMobile()" class="col-12" :class="columnClass">
      <div class="col-12 title">
        {{rating.section_title}}
      </div>
      <div class="col-12 d-flex flex-row" v-for="p in rating.average_ratings" :key="p.rating.field">
        <div class="flex-fill ">{{p.rating.title}}</div>
        <RatingStars :rating="p.rating.rating" :count="p.rating.rating_count" style="height:12px;min-width: 140px" />
      </div>
    </div>
    <div class="col-12 d-flex flex-column" :class="columnClass">
      <div v-for="p in allReviews" :key="p.by_user + p.date" class="margin-top-20 d-flex flex-column">
        <div class="d-flex flex-row">
          <div class="review-user df18-l19-m col-8 p-0">{{p.by_user}} </div>
          <div class="review-date df16-l18-l col-4">{{p.date}} </div>
        </div>
        <div>
          <RatingStars v-if="p.rating > 0" :rating="p.rating" />
        </div>
        <div class="df16-l18-l review-description">
          {{p.description}}
        </div>
        <HorizontalSplitter />
      </div>
      <ButtonComponent v-if="more" :caption="more.label" @click="fetchMore()" @keyup.enter="fetchMore()" class="margin-top-20" />
    </div>
    <div v-if="$isDesktop() && showOverview" class="col-12 col-xl-6">
      <div class="d-flex flex-column justify-content-center mw440 grey-bg">
        <div class="d-flex flex-column justify-content-center mw360 margin-top-100 margin-bottom-50">
          <div class="df28-l40-m align-self-center margin-bottom-50"> {{rating.section_title}}</div>
          <div v-for="p in rating.average_ratings" :key="p.rating.field">
            <div class="d-flex flex-row margin-top-20">
              <div class="df18-l19-m flex-fill">{{p.rating.title}}</div>
              <RatingStars :rating="p.rating.rating" :count="p.rating.rating_count" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {fetch3} from "@/modules/configuration.js";
import RatingStars from "@/components/generic/RatingStars.vue";
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue";
import ButtonComponent from "@/components/form/ButtonComponent";
export default {
  components: {
    RatingStars,
    HorizontalSplitter,
    ButtonComponent
  },
  props: {
    rating: Object,
    showOverview: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      moreReviews: [],
      viewMore: {}
    }
  },
  computed: {
    maxWidthClass() {
      return this.showOverview ? "mw" : "mw440";
    },
    columnClass() {
      return this.showOverview ? "col-xl-6" : "";
    },
    allReviews() {
      return [...this.rating.reviews.list.reviews, ...this.moreReviews]
    },
    more() {
      if (this.moreReviews.length > 0) {
        return this.viewMore;
      }
      return this.rating.view_more;
    }
  },
  methods: {
    async fetchMore() {
      const data = await fetch3(this, {
        url: this.more.href
      });
      this.moreReviews = [...this.moreReviews, ...data.reviews];
      this.viewMore = data.view_more;
    }
  }
}
</script>
<style scoped>
.title {
  font-size: 20px;
  font-weight: bold;
}
.review-user {
  font-weight: bold;
  font-size: 14px;
}
.review-date {
  color: #a0a0a0;
  font-size: 14px;
  text-align: left;
  padding-left: 20px;
}
.review-description {
  color: #505050;
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 12px;
}
</style>